export default __webpack_public_path__ + "static/media/wrong-icon.9f19efa1.svg";